import { useEffect, useState } from 'react';
import { DataTable, DataTableSortStatus, DataTablePaginationProps, DataTableSelectionProps } from 'mantine-datatable';
import { PropagateLoader } from 'react-spinners';
import { sortBy } from 'lodash';
import { Paper, useTheme } from '@mui/material';
import CustomListHeader from './CustomListHeader';
import { CustomListComponentInterface } from '../../../Models/Common/List/ListInterfaces';
import { MantineProvider, ColorSchemeProvider, ColorScheme } from '@mantine/core';

import { TableContainer } from '../../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';

export default function CustomListComponent<T>(props: CustomListComponentInterface<T>) {
  const {
    columns,
    records,
    setRecords,
    idAccessor,
    defaultColumnSort = { columnAccessor: 'id', direction: 'asc' },
    totalRecords = 0,
    page = 1,
    setPage,
    fetching,
    enablePagination = true,
    onRowClick,
    striped = false,
    withBorder = false,
    recordsPerPage = 10,
    onRecordsPerPageChange,
    height = '98%',
    selectedRecords = [],
    onSelectedRecordsChange,
    onSortStatusChange,
  } = props;
  const PAGE_SIZES = [5, 10, 25, 50, 100];
  const recordsPerPageLabel = "Records per page";
  const theme = useTheme();
  const sortStatus = {
        columnAccessor: defaultColumnSort?.columnAccessor ?? idAccessor,
        direction: defaultColumnSort?.direction ?? 'asc'
    };

  //states
  const [colorScheme, setColorScheme] = useState<ColorScheme>("light");
  // const [sortStatus, setSortStatus] = useState<DataTableSortStatus>(defaultColumnSort);

  // useEffect(() => {
  //   const sortedData = sortBy(records, sortStatus.columnAccessor);
  //   const from = (page - 1) * recordsPerPage;
  //   const to = from + recordsPerPage;
  //   if (setRecords) {
  //     setRecords(
  //       sortStatus.direction === 'desc' ? sortedData.reverse().slice(from, to) : sortedData.slice(from, to)
  //     );
  //   }
  // }, [sortStatus, page]);

  useEffect(() => {
      setColorScheme(theme.palette.mode as ColorScheme);
  }, [theme.palette.mode]);

  const datatableOtherProps: Partial<DataTablePaginationProps> = enablePagination
    ? {
      page: page,
      onPageChange: (p: number) => setPage?.(p),
      totalRecords: totalRecords,
      recordsPerPage: recordsPerPage,
      recordsPerPageOptions: PAGE_SIZES,
      onRecordsPerPageChange: onRecordsPerPageChange,
      recordsPerPageLabel: recordsPerPageLabel,
      paginationText: ({ from, to, totalRecords }: { from: number; to: number; totalRecords: number }) =>
        `Showing ${from} to ${to} of ${totalRecords} entries`,
    }
    : {};

  const datatableSelectRecordsProps: Partial<DataTableSelectionProps<T>> = onSelectedRecordsChange
    ? {
      selectedRecords: selectedRecords,
      onSelectedRecordsChange: onSelectedRecordsChange,
    } : {};
  
  return (
    <>
      <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={() => {}}>
        <MantineProvider theme={{ colorScheme }} withGlobalStyles withNormalizeCSS>
          <DataTable
            {...(datatableOtherProps as DataTablePaginationProps)}
            {...(datatableSelectRecordsProps as DataTableSelectionProps<T>)}
            columns={columns}
            idAccessor={idAccessor}
            records={records}
            sortStatus={sortStatus ?? null}
            onSortStatusChange={onSortStatusChange}
            fetching={fetching}
            customLoader={<PropagateLoader className="loaderIcon" color='#17b2a6' size={15} />}
            rowBorderColor={withBorder ? 'lightGray' : 'transparent'}
            // striped={false}
            onRowClick={onRowClick}
            height={height}
            highlightOnHover
            striped={striped}
            sx={{
              minHeight: '250px',
              'thead tr': {
                backgroundColor: colorScheme == "dark" ? "#4d5055" : "var(--mantineHeaderBGColor)",
                
              },
              'tbody tr': {
                backgroundColor: colorScheme == "dark" ? "#1e1e1e" : "var(--cardBgPrimaryColor)",
                
              },
            }}
          // enablePagination={enablePagination}
              />
        </MantineProvider>
        </ColorSchemeProvider>
    </>
  );
}
